import { render, staticRenderFns } from "./fxx.vue?vue&type=template&id=554abb42&scoped=true&"
import script from "./fxx.vue?vue&type=script&lang=js&"
export * from "./fxx.vue?vue&type=script&lang=js&"
import style0 from "./fxx.vue?vue&type=style&index=0&id=554abb42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554abb42",
  null
  
)

export default component.exports